<template>
    <div class="faq-item"
        :class="[{'faq-show': isShow},{'faq-mass': theme == 'mass'},{'faq-prestige': theme == 'prestige'}]">
        <div class="faq-question"
            @click="clickShow">
            <div class="faq-txt">{{question.q}}</div>
            <div class="faq-ic">
                <img class="img-fluid" v-if="isShow && theme == 'mass'" src="./asset/mass/arrow-up@3x.png" />
                <img class="img-fluid" v-if="isShow && theme == 'prestige'" src="./asset/prestige/arrow-up.svg" />
                <img class="img-fluid" v-if="!isShow && theme == 'mass'" src="./asset/mass/arrow-down@3x.png" />
                <img class="img-fluid" v-if="!isShow && theme == 'prestige'" src="./asset/prestige/arrow-down.svg" />
            </div>
        </div>
        <div class="faq-answer" v-if="isShow">
            <p v-html="question.a"></p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FaqItem',
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        question: Object
    },
    data: function () {
        return {
            isShow: false
        };
    },
    methods: {
        //event
        clickShow: function () {
            this.isShow = !this.isShow;
        }
    }
}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
.faq-item {
    .faq-answer {
        p {
            a {
                text-decoration: none;
            }
        }
    }

    &.faq-mass {
        border-bottom: 1px solid #58595b;

        .faq-answer > p > a {
            color: #d41145;
        }
    }

    &.faq-prestige {
        border-bottom: 1px solid #a48f59;

        .faq-answer > p > a {
            color: #a48f59;
        }
    }
}

</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.faq-item {
    padding: {
        top: 20px;
        bottom: 20px;
    };

    .faq-question {
        position: relative;
        padding-right: 20px;

        .faq-txt {
            font-size: 1rem;
            // font-family: $regular;
            word-break: break-word;
            // line-height: 1.4;
        }

        .faq-ic {
            position: absolute;
            top: 50%;
            right: 0;
            width: 15px;
            height: 9px;
            transform: translateY(-50%);

            img {
                display: block;
            }
        }
    }

    .faq-answer {
        p {
            font-size: 1rem;
            // font-family: $regular;
            word-break: break-word;
            // line-height: 1.2;
        }
    }

    &.faq-show {
        padding-bottom: 10px;

        .faq-question {
            margin-bottom: 15px;
        }
    }

    &.faq-mass {
        border-bottom: 1px solid #58595b;

        .faq-question .faq-txt {
            color: $mass_detail_font_color;
        }

        .faq-answer {
            color: $mass_theme_color;
        }
    }

    &.faq-prestige {
        border-bottom: 1px solid #a48f59;

        .faq-question .faq-txt {
            color: $prestige_theme_color;
        }

        .faq-answer {
            color: #a48f59;
        }
    }
}
</style>
